export const faqs = [
  {
    question: "What if I'm not ready to continue after my trial?",
    answer: "No problem at all. If you decide not to continue after your 7-day Essential trial, your account automatically shifts to limited access mode. You keep your existing data, basic dashboard access, your baseline room check, MyDailyCheckIn, limited ThriveCircle access, and 5 companion chats per week. Upgrade anytime when you're ready."
  },
  {
    question: "How does the 7-day trial work for older adults?",
    answer: "Older adults start with full Essential access for 7 days, no credit card required. After the trial, choose to continue with Essential or automatically move to limited access mode where your data is always preserved. You'll still have access to limited ThriveCircle access and 5 companion chats per week."
  },
  {
    question: "How does the free trial work for family members?",
    answer: "Family members can explore the platform for free with no time limit! You'll have access to preview features and learn about SeniorThrive. Payment only begins when your older adult loved one activates their account and you choose a family plan."
  },
  {
    question: "What happens after my trial ends?",
    answer: "If you don't upgrade, you'll automatically move to limited access mode (free forever) with basic features, read-only access to your trial data, limited ThriveCircle access, and 5 companion chats per week."
  },
  {
    question: "Can I upgrade or downgrade anytime?",
    answer: "Yes! You can change plans anytime. Upgrades take effect immediately, and downgrades take effect at your next billing cycle."
  },
  {
    question: "Is the Family plan free to explore?",
    answer: "Yes, it's free to explore. You can create your Family Dashboard and invite others anytime. Billing only begins once your loved one activates their Thrive account."
  },
  {
    question: "How will I know when billing starts?",
    answer: "You'll get a notification and confirmation email before activation billing begins, no hidden charges."
  },
  {
    question: "Can multiple family members join before activation?",
    answer: "Absolutely. The older adult plus up to 4 family members (5 people total) can explore SeniorThrive together, all free until activation."
  },
  {
    question: "What care tools are included with the Family plan?",
    answer: "The Family plan includes hands-on care tools for families managing more complex caregiving situations. You get expanded care coordination, visit scheduling, care notes, incident reporting, condition-specific care packs, and self-care reminders, all included at no extra cost."
  },
  {
    question: "What is the Care Team Add-On?",
    answer: "The Care Team add-on allows families to invite professional caregivers into their ThriveCircle. Professional caregivers get access to care documentation, scheduling, and communication tools, all within the family's existing care coordination system. Available when invited by a family using the Family plan."
  }
];
